import { computed, inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { I18n, I18nHelper } from '@core/i18n';

@Injectable({ providedIn: 'root' })
export class I18nService {
    private readonly _lang = signal<I18n>(I18n.EN);
    readonly lang = computed(() => this._lang());

    private translateService = inject(TranslateService);

    constructor() {
        this._lang.set(this.translateService.currentLang as I18n);
    }

    initialize(): void {
        this.setLanguage(I18nHelper.initialize());
    }

    setLanguage(lang: I18n) {
        this.translateService.use(lang);
        this._lang.set(lang);
        localStorage.setItem(I18nHelper.STORAGE_KEY, lang);
    }
}
